import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@roger/ui-components';
import { Loader2 } from 'lucide-react';
import type { BulkTemplateStatusDialogState } from './useBulkTemplateStatus';

export function BulkTemplateStatusDialog({
  dialog,
  busy,
  onClose,
  onConfirm,
}: {
  dialog: BulkTemplateStatusDialogState | null;
  busy: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Dialog
      open={dialog != null}
      onOpenChange={open => {
        if (!open && !busy) {
          onClose();
        }
      }}
    >
      <DialogContent className='max-w-md'>
        <DialogHeader>
          <DialogTitle>
            {dialog?.direction === 'resume'
              ? 'Resume paused rendering'
              : 'Pause live rendering'}
          </DialogTitle>
          <DialogDescription asChild>
            <div className='space-y-3 text-muted-foreground text-sm'>
              <p>{dialog?.scopeSummary}</p>
              <p className='text-foreground font-medium'>
                {dialog?.affectedCount ?? 0} template
                {(dialog?.affectedCount ?? 0) === 1 ? '' : 's'} will be updated
                (
                {dialog?.direction === 'resume'
                  ? 'Paused → Live'
                  : 'Live → Paused'}
                ).
              </p>
              <p>
                Templates with <span className='font-medium'>Standby</span>{' '}
                status are not changed.
              </p>
            </div>
          </DialogDescription>
        </DialogHeader>
        {/* No gap override: DialogFooter's default gap-2 now covers both
            breakpoints; sm:gap-0 would strip the desktop spacing that used
            to come from sm:space-x-2. */}
        <DialogFooter>
          <Button
            type='button'
            variant='outline'
            disabled={busy}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            type='button'
            disabled={busy || (dialog?.affectedCount ?? 0) === 0}
            onClick={onConfirm}
          >
            {busy ? (
              <>
                <Loader2 className='h-4 w-4 mr-2 animate-spin' aria-hidden />
                Updating…
              </>
            ) : dialog?.direction === 'resume' ? (
              'Resume'
            ) : (
              'Pause'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
